import React, { useEffect, useState } from "react";

import BNBox from "../BNBox/BNBox";
import fetchSvg from "./../../Helpers/fetchSvg/fetchSvg";
import logger from "../../Helpers/logger/logger";
import { SxProps, Theme } from "@mui/material/styles";
import { sxEnsureArray } from "../../Helpers/sxMerge";
import { BoxProps } from "@mui/system";

export interface BNInlineSvgIconProps {
  src?: string;
  svgString?: string;
  sx?: SxProps<Theme>;
}

const BNInlineSvgIcon: React.FC<BNInlineSvgIconProps> = (props) => {
  const { sx: sxInput, src, svgString } = props;
  const abortController = new AbortController();

  const [svg, setSvg] = useState(svgString);
  const sx: BoxProps["sx"] = [
    {
      width: "2.4rem",
      height: "2.4rem",
      ["& svg"]: {
        width: "inherit",
        height: "inherit",
      },
    },
    ...sxEnsureArray(sxInput),
  ];
  useEffect(() => {
    if (!src) {
      return;
    }
    fetchSvg(src, abortController.signal)
      .then((svg) => {
        if (typeof svg === "string") {
          const isSvg = svg.startsWith("<?xml") || svg.startsWith("<svg") || svg.startsWith("<xml");
          if (isSvg && !abortController.signal.aborted) setSvg(svg);
        }
      })
      .catch((error) => {
        // Don't log AbortError due to unmount as this i expected behaviour
        if (abortController.signal.aborted) return;

        logger.logError(error);
      });

    return () => {
      abortController.abort();
    };
  }, []);

  if (!svg) {
    // Return placeholder to avoid cls
    return (
      <BNBox aria-hidden={true} sx={sx}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" />
      </BNBox>
    );
  }

  return <BNBox aria-hidden={true} sx={sx} dangerouslySetInnerHTML={{ __html: svg }} />;
};
export default BNInlineSvgIcon;
